import { render, staticRenderFns } from "./NoteMenu.vue?vue&type=template&id=ae8c0f86&scoped=true&"
import script from "./NoteMenu.vue?vue&type=script&lang=js&"
export * from "./NoteMenu.vue?vue&type=script&lang=js&"
import style0 from "./NoteMenu.vue?vue&type=style&index=0&id=ae8c0f86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8c0f86",
  null
  
)

export default component.exports